import { render, staticRenderFns } from "./MealDetail2.vue?vue&type=template&id=19780dbb&"
import script from "./MealDetail2.vue?vue&type=script&lang=js&"
export * from "./MealDetail2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports